var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('button',{staticClass:"btn-close",attrs:{"type":"button"},on:{"click":_vm.closeModal}}),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"action-button",class:{ disabled: _vm.actionDisabled },on:{"click":_vm.callAction}},[_vm._v(" "+_vm._s(_vm.actionText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }